import { useState } from "react";
import styles from "./StatisticsTab.module.css";
import CustomSelect from '../../customComponents/CustomSelect';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { FaChartBar, FaUndoAlt, FaTruck, FaMoneyBillWave, FaChartLine, FaReceipt } from "react-icons/fa";

const data = [
  { time: "00:00", sales: 0 },
  { time: "02:00", sales: 0 },
  { time: "04:00", sales: 0 },
  { time: "06:00", sales: 0 },
  { time: "08:00", sales: 0 },
  { time: "10:00", sales: 0 },
  { time: "12:00", sales: 0 },
  { time: "14:00", sales: 0 },
];

const StatisticsTab = () => {
  const [Select, setSelect] = useState('');
  
  return (
    <div className={styles.container}>
      <div className={styles.SelectBox}>
        <CustomSelect
          className={styles.filters__select}
          options={['Select 1', 'Select 2 ', 'Select 3', 'Select 4']}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <CustomSelect
          className={styles.filters__select}
          options={['Select 1', 'Select 2 ', 'Select 3', 'Select 4']}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
      </div>
      {/* Верхняя часть — карточки */}
      <div className={styles.topSection}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <FaChartBar className={`${styles.icon} ${styles.blue}`} />
            <span>Продажи</span>
          </div>
          <div className={styles.cardStats}>
            <div>
              <p>Сумма продажи</p>
              <h3>0 ₸</h3>
            </div>
            <div>
              <p>Количество</p>
              <h3>0</h3>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <FaUndoAlt className={`${styles.icon} ${styles.orange}`} />
            <span>Возврат</span>
          </div>
          <div className={styles.cardStats}>
            <div>
              <p>Сумма возвратов</p>
              <h3>0 ₸</h3>
            </div>
            <div>
              <p>Количество</p>
              <h3>0</h3>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <FaTruck className={`${styles.icon} ${styles.green}`} />
            <span>Приемка</span>
          </div>
          <div className={styles.cardStats}>
            <div>
              <p>Сумма приемки</p>
              <h3>0 ₸</h3>
            </div>
            <div>
              <p>Количество</p>
              <h3>0</h3>
            </div>
          </div>
        </div>
      </div>

      {/* График */}
      <div className={styles.chartContainer}>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="sales"
              stroke="#1d8752"
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
        <p className={styles.noData}>Нет данных для отображения</p>
      </div>

      {/* Правая колонка с выручкой */}
      <div className={styles.sideStats}>
        <div className={styles.smallCard}>
          <FaMoneyBillWave className={`${styles.icon} ${styles.blue}`} />
          <div>
            <p>Выручка</p>
            <h3>0 ₸</h3>
          </div>
        </div>

        <div className={styles.smallCard}>
          <FaChartLine className={`${styles.icon} ${styles.green}`} />
          <div>
            <p>Чистая прибыль</p>
            <h3>0 ₸</h3>
          </div>
        </div>

        <div className={styles.smallCard}>
          <FaChartBar className={`${styles.icon} ${styles.purple}`} />
          <div>
            <p>Средний чек</p>
            <h3>0 ₸</h3>
          </div>
        </div>

        <div className={styles.smallCard}>
          <FaReceipt className={`${styles.icon} ${styles.orange}`} />
          <div>
            <p>Счет на оплату</p>
            <h3>0</h3>
          </div>
        </div>
      </div>

      {/* Нижние таблицы */}
      <div className={styles.bottomSection}>
        <div className={styles.tableBlock}>
          <h4>Информация о сотрудниках</h4>
          <table>
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Должность</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3" className={styles.noDataText}>
                  Нет данных для отображения
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={styles.tableBlock}>
          <h4>Продающиеся товары по категориям</h4>
          <table>
            <thead>
              <tr>
                <th>Категория</th>
                <th>Количество</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3" className={styles.noDataText}>
                  Нет данных для отображения
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatisticsTab;
